/* Which page am I on? - and where does the account icon go?

   Marks the header nav item (and the mobile drawer row) for the page being
   viewed with .gs-here. The look is in gs-bits.css: bold, plus a rule under
   the word that breathes slowly so the eye finds it without it shouting.

   Horizon has no current-page state of its own worth using, and it rebuilds
   the header on navigation, so this re-runs on a MutationObserver. Watching
   childList only is deliberate: adding a class is an attribute mutation, so
   marking cannot retrigger the observer.

   ONLY THE TOP ROW, ONE WINNER PER SCOPE. The first version of this looked at
   every link in the header and marked all of them that shared the winning
   address. Every category link in the Products mega panel points at
   /pages/products?category=..., and stripping the query leaves twelve links
   that all look like the winner - so the whole dropdown lit up. The scopes
   below only ever see the top-level items and the drawer's main rows.

   WHAT COUNTS AS BEING ON A PAGE. Exact path, or any path underneath it, so
   /blogs/news/the-future-of-construction lights up News. A product page or a
   collection page lights up Products, because that is where a visitor would
   say they are even though the address says otherwise. Home matches only
   itself, or it would be lit on every page.

   THE ACCOUNT ICON IS SENT TO /pages/team. Tuttu, 8 October, on being taken
   to Shopify's hosted customer account page: "this is like a weird window
   that's coming". It is hosted by Shopify, not by this theme - its own
   header, its own styling, an Orders tab for a store with no cart - and no
   theme file exists that could restyle it. Since the dashboard is the only
   thing an account is for here, the icon points there instead and nobody
   arrives at the Shopify page by accident. Somebody signed out lands on the
   dashboard's own sign-in panel, which then hands over to Shopify's login,
   which is the one screen in that flow we cannot avoid and do not need to.

   This lives here rather than in its own file because the header is rebuilt
   on navigation and this file already watches for that. */

(function () {
  'use strict';

  var MARK = 'gs-here';
  var HOME = '/pages/team';

  function tidy(path) {
    var p = String(path || '').split('?')[0].split('#')[0];
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p || '/';
  }

  /* The path the nav should be judged against, which is not always the path
     in the address bar. */
  function here() {
    var p = tidy(window.location.pathname);
    if (p.indexOf('/products/') === 0) return '/pages/products';
    if (p.indexOf('/collections') === 0) return '/pages/products';
    return p;
  }

  /* How well a link claims this page, as a length so the longest wins. */
  function claim(href, spot) {
    var h = tidy(href);
    if (h === spot) return h.length + 1;
    if (h === '/') return 0;
    if (spot.indexOf(h + '/') === 0) return h.length;
    return 0;
  }

  /* One scope, one winner. */
  function best(pairs, spot) {
    var top = null;
    var score = 0;
    pairs.forEach(function (pair) {
      var n = claim(pair.href, spot);
      if (n > score) { score = n; top = pair; }
    });
    return top;
  }

  function headerPairs() {
    var out = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.menu-list__list-item'),
      function (item) {
        /* The item's own link is the first anchor inside it; anything after
           that belongs to the panel it opens. */
        var link = item.querySelector('a[href]');
        if (!link) return;
        out.push({ href: link.getAttribute('href'), nodes: [link, item] });
      }
    );
    return out;
  }

  function drawerPairs() {
    var out = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.menu-drawer__menu-item--mainlist[href]'),
      function (link) {
        out.push({
          href: link.getAttribute('href'),
          nodes: [link, link.closest ? link.closest('li') : null]
        });
      }
    );
    return out;
  }

  function mark() {
    var spot = here();

    Array.prototype.forEach.call(document.querySelectorAll('.' + MARK), function (el) {
      el.classList.remove(MARK);
    });

    [best(headerPairs(), spot), best(drawerPairs(), spot)].forEach(function (win) {
      if (!win) return;
      win.nodes.forEach(function (node) {
        if (node) node.classList.add(MARK);
      });
    });
  }

  /* Sign out has to keep working, and the login screen is Shopify's whether
     we like it or not - only the account landing page is redirected. */
  function accountLinks() {
    var scope = document.querySelector('.header-section') ||
                document.querySelector('header') || document;

    Array.prototype.forEach.call(scope.querySelectorAll('a[href*="/account"]'), function (a) {
      var raw = a.getAttribute('href') || '';
      var path = tidy(raw.replace(/^https?:\/\/[^/]+/, ''));

      if (path !== '/account') return;
      if (a.dataset.gsSent === '1') return;

      a.setAttribute('href', HOME);
      a.dataset.gsSent = '1';
    });
  }

  function run() {
    mark();
    accountLinks();
  }

  var pending = null;
  function soon() {
    window.clearTimeout(pending);
    pending = window.setTimeout(run, 90);
  }

  function watch() {
    run();

    var head = document.querySelector('.header-section') || document.querySelector('header');
    if (head && 'MutationObserver' in window) {
      new MutationObserver(soon).observe(head, { childList: true, subtree: true });
    }

    var drawer = document.querySelector('.menu-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(soon).observe(drawer, { childList: true, subtree: true });
    }

    window.addEventListener('popstate', soon);
    window.addEventListener('pageshow', soon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
